module.exports = "/images/vendor/vue2vis/dist/upArrow.png?f0aa0566b9f39334bd886d27d6a4cfe1";